module.exports = __webpack_public_path__ + "img/Cicer_arietinum.212d599d.jpg";